import { ModalConfig } from '@/models/ModalConfig';
import { action } from 'typesafe-actions';
import { CommonTypes, FloatingCourseActionsBarConfiguration } from './types';

export const setFloatingCourseActionsConfiguration = (config: FloatingCourseActionsBarConfiguration) =>
    action(CommonTypes.SET_FLOATING_COURSE_ACTIONS_CONFIGURATION, config);

export const openModal = (modalConfig: ModalConfig) => action(CommonTypes.OPEN_MODAL, modalConfig);
export const closeModal = (modalId: string) => action(CommonTypes.CLOSE_MODAL, modalId);
export const clearModal = () => action(CommonTypes.CLEAR_MODAL);
